import { range } from 'libraries/lodash'
import React from 'react'
import cx from 'classnames'
import Skeleton from '@material-ui/lab/Skeleton'
import Divider from '@material-ui/core/Divider'

const CaAccordionSkeleton = ({ windowHeight, headerHeight }) => (
  <div
    className='w-100 overflow-y-auto bg-ghost-grey flex justify-center scrolling-container flex-wrap'
    style={{ maxHeight: `${windowHeight - headerHeight}px` }}
  >
    <div className='grow-1 shrink-1 basis0 ph0 ma0'>
      <div className='content-view'>
        <div className='bg-ghost-grey pb8 mb6'>
          <ul className='group cd-accordion-menu'>
            {range(0, 2).map((_, index) => (
              <li key={index}>
                <AccordionTitle />
                <div className='bg-white'>
                  <ul className='group cd-accordion-menu'>
                    {range(0, 5).map((_, index) => (
                      <GroupHeader key={index} isLast={index + 1 === 8} />
                    ))}
                  </ul>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </div>
)

const AccordionTitle = () => (
  <div className='ma0 ph6 pv5 bg-white bb b--light-sea-green-2 db w-100 o-60'>
    <div className='flex items-center justify-center justify-between h-100 w-100'>
      <Skeleton classes={{ root: 'w11 bg-grey', text: 'f5 fw7' }} />
      <div className='flex items-center justify-center'>
        <div className='o-60 ml5'>
          <Skeleton variant='circle' classes={{ root: 'bg-grey' }} width={24} height={24} />
        </div>
      </div>
    </div>
  </div>
)

const GroupHeader = () => (
  <li className='mb0'>
    <div
      className={cx(
        'w-100 f5 b ma0 pv0 min-h3 shadow-none flex items-center bg-white group'
      )}
    >
      <div
        className='mr9 flex items-center justify-center justify-between h-100 w-100'
        style={{ marginLeft: '2.75rem' }}
      >
        <div className='o-60'>
          <Skeleton variant='text' classes={{ root: 'w14 bg-grey', text: 'f5 fw7' }} />
        </div>
        <div className='flex items-center justify-center'>
          <div className='o-60 ml5'>
            <Skeleton variant='circle' classes={{ root: 'bg-grey' }} width={24} height={24} />
          </div>
          <div className='o-60 ml6'>
            <Skeleton variant='circle' classes={{ root: 'bg-grey' }} width={24} height={24} />
          </div>
        </div>
      </div>
    </div>
    <div className={cx('ph4 mv0')}>
      <Divider variant='fullWidth' classes={{ middle: 'mv0 mh8 bt bt--phantom-grey' }} />
    </div>
  </li>
)

export default CaAccordionSkeleton
